"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlatformLoader = void 0;
const utils_1 = require("@juvare/common-web-ui/utils");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const stores_1 = require("../stores");
const usePreloader_1 = require("./usePreloader");
const useUserClient_1 = require("./useUserClient");
function usePlatformLoader(params) {
    var _a;
    const user = (0, react_redux_1.useSelector)(getUser);
    const dispatch = (0, react_redux_1.useDispatch)();
    const userClient = (0, useUserClient_1.useUserClient)();
    const appContext = params.appContext ? react_1.default.useContext(params.appContext) : undefined; // will be removed in future
    const onStatelessReload = () => __awaiter(this, void 0, void 0, function* () {
        var _b;
        const result = yield userClient.getUserState();
        if (JSON.stringify(result.state) !== JSON.stringify((_b = user === null || user === void 0 ? void 0 : user.data) === null || _b === void 0 ? void 0 : _b.state)) {
            dispatch(stores_1.platformSlice.actions.setUser(result));
        }
        return result;
    });
    const { status, onReload } = (0, usePreloader_1.usePreloader)({
        status: (_a = user === null || user === void 0 ? void 0 : user.status) !== null && _a !== void 0 ? _a : 'initial',
        onLoad: () => {
            dispatch(stores_1.platformSlice.actions.setLoading());
            return userClient.getUserState();
        },
        onSuccess: (result) => {
            dispatch(stores_1.platformSlice.actions.setUser(result));
            appContext === null || appContext === void 0 ? void 0 : appContext.initState(result); // will be removed in future
        },
        onError: (error) => {
            dispatch(stores_1.platformSlice.actions.setError((0, utils_1.getErrorMessage)(error)));
        },
    });
    return {
        status: status === 'error' ? 'done' : status,
        onReload,
        onStatelessReload,
    };
}
exports.usePlatformLoader = usePlatformLoader;
function getUser(state) {
    return state.platform.user;
}
